<template>
  <div class="loading-layer" @touchmove.prevent>
    <!-- <img src="../assets/img/logo_tc.png" class="logo" /> -->
    <div class="progress-bar">
      <div class="grow-bar" :style="{ width: progress + '%' }"></div>
      <div class="progress-num">{{ pTxt }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingLayer",
  props: ["progress"],
  computed: {
    pTxt() {
      return Math.floor(this.progress).toString();
    }
  }
};
</script>

<style lang="less" scoped>
.loading-layer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  // background: url("../assets/img/bg.jpg") 0 0 no-repeat;
  // background-size: 100% 100%;
  background-color: #fff;
  z-index: 1000;
  .progress-bar {
    width: 450px;
    height: 20px;
    background-color: #dee3ba;
    margin: 45px auto 40px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -100%);
    border-radius: 22px;
    .grow-bar {
      position: absolute;
      background-color: #f6c300;
      height: 100%;
      border-radius: 22px;
    }
    .progress-num {
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: -50px;
      font-size: 24px;
    }
  }
}
</style>
